/* eslint-disable import/no-cycle */
import axios from 'axios';
import { getToken } from './auth.service';

const CORUJA_API_BASE_URL = 'http://coruja-api.localhost:8000/api';

const notificationsApi = axios.create({
  baseURL: CORUJA_API_BASE_URL,
});

notificationsApi.interceptors.request.use((request) => {
  const token = getToken();
  if (token) {
    request.headers.authorization = `Bearer ${token}`;
  }
  return request;
});

export default notificationsApi;
